function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.87297 7.75405L14.7919 2.7973C15.0189 2.57027 15.0189 2.22973 14.7919 2.0027L14.0351 1.20811C13.8081 0.981081 13.4676 0.981081 13.2405 1.20811L8.28378 6.16486C8.13243 6.31622 7.90541 6.31622 7.75405 6.16486L2.7973 1.17027C2.57027 0.943243 2.22973 0.943243 2.0027 1.17027L1.20811 1.96486C0.981081 2.19189 0.981081 2.53243 1.20811 2.75946L6.16487 7.71622C6.31622 7.86757 6.31622 8.09459 6.16487 8.24594L1.17027 13.2405C0.943243 13.4676 0.943243 13.8081 1.17027 14.0351L1.96486 14.8297C2.19189 15.0568 2.53243 15.0568 2.75946 14.8297L7.71622 9.87297C7.86757 9.72162 8.09459 9.72162 8.24595 9.87297L13.2027 14.8297C13.4297 15.0568 13.7703 15.0568 13.9973 14.8297L14.7919 14.0351C15.0189 13.8081 15.0189 13.4676 14.7919 13.2405L9.87297 8.28378C9.72162 8.13243 9.72162 7.9054 9.87297 7.75405Z"
});

function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.400260247cd2ad198003df4ffd656c49.svg";
export { ForwardRef as ReactComponent };